// extracted by mini-css-extract-plugin
export var active = "Tabs-module--active--n6+DP";
export var activeCode = "Tabs-module--activeCode--im8uN";
export var code = "Tabs-module--code--PRPe+";
export var codeBlock = "Tabs-module--codeBlock--brCV0";
export var root = "Tabs-module--root--VWDGV";
export var tab = "Tabs-module--tab--tgHHC";